import { type ThemeMode } from "@root/tablescape/state";
import { type TTailwindString } from "classnames";

export const enum BentoBoxLayout {
  A = "a",
  B = "b",
}

type BentoBoxCardAlignX = "left" | "center";
type BentoBoxCardAlignY = "top" | "center" | "bottom";
type BentoBoxCardBackgroundColor = "brick" | "char" | "sage" | "blue" | "bone";
type BentoBoxCardContentWidthPercentage = "50" | "75" | "100";
type BentoBoxCardTextColor = "white" | "char";
type BentoBoxCardTitleSize =
  | "display"
  | "xxl"
  | "xl"
  | "lg"
  | "md"
  | "sm"
  | "xs";

type BentoBoxCardProps = {
  alignX?: BentoBoxCardAlignX;
  alignY?: BentoBoxCardAlignY;
  backgroundColor?: BentoBoxCardBackgroundColor;
  btnLabel?: string;
  className?: TTailwindString;
  contentWidthPercentage: BentoBoxCardContentWidthPercentage;
  descriptionText?: string;
  eyebrowText?: string;
  handleCtaClick?: () => void;
  imageUrl?: string;
  loopVideo: boolean;
  modalContent?: {
    eyebrowText?: string;
    items: {
      bodyText?: string;
      desktopImage?: string;
      mobileImage?: string;
      titleText?: string;
    }[];
    showModal: boolean;
    titleText?: string;
  };
  position: number;
  textColor?: BentoBoxCardTextColor;
  titleSize?: BentoBoxCardTitleSize;
  titleText?: string;
  videoMp4?: string;
  videoWebm?: string;
};

type BentoBoxSectionSettings = {
  cards: BentoBoxCardProps[];
  layout: BentoBoxLayout;
  subtitleText1?: string;
  subtitleText2?: string;
  text: {
    btnLabel: string;
    closeBtnAlt: string;
  };
  theme: ThemeMode;
  titleText?: string;
};

export type {
  BentoBoxCardAlignX,
  BentoBoxCardAlignY,
  BentoBoxCardBackgroundColor,
  BentoBoxCardContentWidthPercentage,
  BentoBoxCardTextColor,
  BentoBoxCardTitleSize,
  BentoBoxCardProps,
  BentoBoxSectionSettings,
};
